import React, { FC, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Alert, Snackbar } from '@mui/material';

import { MasterKey } from '@shared/types';

import CreateKeyForm from './CreateKeyForm';
import KeysTable from './KeysTable';
import { useFetchGameKeys, useDeleteGameKey, useDeleteMultipleGameKeys } from './master.actions';

import '../Partner/Dashboard/Dashboard.scss';
import './index.scss';

interface MasterPageProps {
  masterKey: MasterKey;
}

const MasterPage: FC<MasterPageProps> = ({ masterKey }) => {
  const { t } = useTranslation();
  const [gameKeys, fetchGameKeys, fetchError] = useFetchGameKeys();
  const [_, deleteGameKey, deleteError] = useDeleteGameKey();
  const [___, deleteMultipleGameKeys, bulkDeleteError] = useDeleteMultipleGameKeys();
  const [error, setError] = useState<string | null>(null);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    console.log('🔄 Initial fetchGameKeys called');
    fetchGameKeys();
  }, []);

  // Обработка ошибок из actions
  useEffect(() => {
    console.log('fetchError changed:', fetchError);
    if (fetchError) {
      const errorMessage = t('master.fetchError', { error: fetchError });
      console.log('Setting fetch error:', errorMessage);
      setError(errorMessage);
      setShowError(true);
    }
  }, [fetchError, t]);

  useEffect(() => {
    console.log('deleteError changed:', deleteError);
    if (deleteError) {
      const errorMessage = t('master.deleteError', { error: deleteError });
      console.log('Setting delete error:', errorMessage);
      setError(errorMessage);
      setShowError(true);
    }
  }, [deleteError, t]);

  useEffect(() => {
    console.log('bulkDeleteError changed:', bulkDeleteError);
    if (bulkDeleteError) {
      // Показываем оригинальную ошибку, если перевод недоступен
      const errorMessage = t('master.bulkDeleteError', { error: bulkDeleteError }) || 
                          `Ошибка массового удаления: ${bulkDeleteError}`;
      console.log('Setting bulk delete error:', errorMessage);
      setError(errorMessage);
      setShowError(true);
    }
  }, [bulkDeleteError, t]);

  // Отладочная информация
  useEffect(() => {
    console.log('Current error state:', { error, showError });
  }, [error, showError]);

  // Логирование обновлений gameKeys
  useEffect(() => {
    console.log('📊 gameKeys updated:', gameKeys?.length || 0, 'keys');
  }, [gameKeys]);

  // Закрытие уведомления об ошибке
  const handleCloseError = () => {
    console.log('Closing error notification');
    setShowError(false);
    setError(null);
  };



  return (
    <div className="partner-dashboard master-page">

      <div className="partner-dashboard__content">
        <div className="partner-dashboard__create-section">
          <CreateKeyForm refetch={fetchGameKeys} />
        </div>

        <div className="partner-dashboard__games">
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <div className="partner-dashboard__section-title">Ключи ({gameKeys?.length || 0})</div>
          </div>
          <div className="partner-dashboard__table" style={{ padding: 16 }}>
            <KeysTable
              onDeleteClick={deleteGameKey}
              onBulkDeleteClick={deleteMultipleGameKeys}
              refetch={fetchGameKeys}
              gameKeys={gameKeys}
            />
          </div>
        </div>
      </div>

      <Snackbar
        open={showError}
        autoHideDuration={6000}
        onClose={handleCloseError}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseError}
          severity="error"
          sx={{ width: '100%' }}
        >
          {error}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default MasterPage;
